import { cn } from "@/lib/utils";
import { TASK_STATUS_LABELS, type TaskStatus } from "@/lib/tasks";

export function TaskStatusBadge({ status }: { status: TaskStatus }) {
  const colorClass =
    status === "Completed"
      ? "bg-success/15 text-success"
      : status === "Cancelled"
        ? "border border-border text-foreground"
        : "bg-info/15 text-primary";
        
  return (
    <span className={cn("inline-block rounded px-2 py-0.5 text-xs font-medium", colorClass)}>
      {TASK_STATUS_LABELS[status]}
    </span>
  );
}
